<template>
  <div class="panel-dropdown">
    <span :class="{'text-danger': invalid}">
      <slot name="start"></slot>
    </span>

    <input
      class="form-control"
      ref="input"
      :placeholder="$attrs.placeholder"
      :readonly="selected !== null"
      :disabled="$attrs.disabled"
      @click="onCLick"
      @keyup="onSearch($event.target.value)"
    />
    <span v-if="!$attrs.disabled && selected !== null" @click.prevent="remove">
      <slot name="clearIcon">
        <i class="icon pull-left pointer icon_close_alt" />
      </slot>
    </span>
    <transition name="fade"  mode="out-in">
    <div class="panel-dropdown-content" :disabled="$attrs.disabled">
      <ul>
        <li class="no-result" v-if="items.length <= 0">
          <slot name="noData">
            <span>No items found</span>
          </slot>
        </li>

        <li
          v-for="(item, index) in items"
          v-bind:key="index"
          class="item"
          @click="selectItem(item)"
        >
          <slot name="item" v-bind:item="item">
            <span>{{ item[itemText] }}</span>
          </slot>
        </li>
      </ul>
    </div>
     </transition>
  </div>
</template>
<script>
export default {
  data: () => ({
    invalid: false,
    selected: null,
  }),

  props: {
    items: { type: Array, default: () => [] },
    itemText: { type: String, required: true },
  },

  methods: {
    selectItem: function (item) {
      if (item && typeof item === "object" && item[this.itemText])
        this.$refs.input.value = item[this.itemText];

      this.selected = item;
      this.$emit("onSelect", item);

      this.onClosePanel();
    },

    onSearch: function (val) {
      this.$emit("onSearch", val);
      this.onClosePanel();
      this.$el.classList.add("active");
    },

    onClosePanel: function () {
      this.$el.classList.remove("active");
       this.$el.classList.remove("focused-hotel-location");
         this.$el.classList.remove("focused-dest-location");
    },

    onCLick: function () {
      if (this.$el.classList.contains("active")) {
        this.onClosePanel();
      } else {
        this.onClosePanel();
        this.$el.classList.add("active");
      }
    },

    remove() {
      this.$refs.input.value = null;
      this.selected = null;
      this.onSearch("");
    },

    validate() {
      this.invalid = this.selected === null;
    },
  },

  mounted() {
    let mouse_is_inside = false;
    this.$el.addEventListener("mouseenter", () => (mouse_is_inside = true));
    this.$el.addEventListener("mouseleave", () => (mouse_is_inside = false));
    document.querySelector("body").addEventListener("mouseup", () => {
      if (!mouse_is_inside) this.onClosePanel();
    });
  },
};
</script>
<style scoped>
.fade-enter { opacity: 0 }
.fade-enter-active { transition: opacity 2s ease }
.fade-leave {}
.fade-leave-active { transition: opacity 2s ease; opacity: 0}
.focused-hotel-location{
border: 1px solid #e35c67 !important;
    margin-bottom: -1px !important;
}
.focused-hotel-location input
{
 color: #e35c67;
}

.focused-dest-location{
border: 1px solid #1f80cf !important;
    margin-bottom: -1px !important;
}
.focused-dest-location input
{
 color: #1f80cf;
}
/* .selected-dest {
  color: #21376d;
} */
.pdk-loading-bar {
  position: absolute;
  bottom: 0px;
  width: 100%;
  z-index: 1000;
}
.panel-dropdown > input {
  padding-right: 45px;
  border-left: 0;
  height: 60px !important;
}
.panel-dropdown > input:after {
  font-family: ElegantIcons;
  content: "\33";
  font-size: 26px;
  color: #999;
  font-weight: 500;
  -moz-transition: all 0.8s ease-in-out;
  -o-transition: all 0.8s ease-in-out;
  -webkit-transition: all 0.8s ease-in-out;
  -ms-transition: all 0.8s ease-in-out;
  transition: all 0.8s ease-in-out;
  position: absolute;
  right: 0;
  top: 0;
}
.panel-dropdown > input:after {
  left: 0 !important;
  right: auto !important;
}
.panel-dropdown.active > input:after {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.panel-dropdown.active > a:after {
  transform: rotate(180deg);
}
.panel-dropdown {
  min-height: 100%;
  padding: 0;
}
.panel-dropdown .panel-dropdown-content {
  width: 100% !important;
}
.panel-dropdown .panel-dropdown-content:after {
  content: unset !important;
}
.panel-dropdown-content {
  padding: 0px;
  overflow-y: auto;
  max-height: 300px;
}
.panel-dropdown-content > input {
  border: none;
  padding: 0.375rem 0.75rem;
  padding-right: 30px;
}
.panel-dropdown-content > ul {
  list-style: none;
  padding-right: 0px;
  margin: 0;
}
.panel-dropdown-content > ul > li {
  padding: 10px 10px 10px 0;
  cursor: pointer;
}
.panel-dropdown-content > ul > li.item:hover {
  background: #e8ecfb;
}
.panel-dropdown-content > ul > li.item:hover > span {
  color: black;
}
.panel-dropdown-content > ul > li > span:first-child {
  margin-bottom: 5px;
  /* display: block; */
  margin-left: 10px;
}
.panel-dropdown-content > ul > li > small {
  color: #999;
  position: absolute;
  left: 15px;
}
.panel-dropdown-content > ul > li:last-child {
  border-bottom: none;
}
.panel-dropdown-content > ul > li > span {
  font-size: 12pt;
  text-decoration: none;
  color: black;
}
.panel-dropdown-content > ul > li.has-error,
.panel-dropdown-content > ul > li.no-result {
  cursor: default;
}
.panel-dropdown-content > ul > li.no-result > span {
  color: #999;
}
.panel-dropdown-content > ul > li.is-loading {
  padding-left: 10px;
}
.panel-dropdown-content > ul > li.has-error > span {
  color: rgb(158, 12, 12);
}
.form-control:disabled,
.form-control[readonly] {
  background-color: unset;
}
@media (max-width:478px){
  .panel-dropdown > input {
    height: 40px !important;
  }
}
</style>